module.exports = __webpack_public_path__ + "static/media/about-banner@mobile-mtn.e9b8004c.png";